import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=538e1170&scoped=true&"
import script from "./Blogs.vue?vue&type=script&lang=js&"
export * from "./Blogs.vue?vue&type=script&lang=js&"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=538e1170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e1170",
  null
  
)

export default component.exports